
import { User } from "@/models/user";
import { UserService } from "@/services/user-service";
import Vue from "vue";
export default Vue.extend({
	data(){
		return {
			url: "",
			expiryDate: new Date(),
			isFetching: false,
			fetchedUserId: 0
		};
	},
	props: {
		user: {
			type: Object as ()=> User,
		},
		admin: Boolean,
		disabled: Boolean,
	},
	computed: {
		isDisabled():boolean{
			if (this.isFetching) {
				return true;
			}
			return this.disabled;
		}
	},
	methods: {
		async onClick(event:MouseEvent){
			if (!this.user) return;
			if (this.admin) {
				await UserService.loginAsAdmin(this.user);
			}else{
				await UserService.loginAsUser(this.user);
			}
		},
		async onHover(){
			if (!this.user) return;
			if (this.fetchedUserId != this.user.id) {
				await this.fetchUrl();
				return;
			}
			if (!this.url) {
				await this.fetchUrl();
				return;
			}
			if (this.expiryDate.getTime() < new Date().getTime()) {
				await this.fetchUrl();
				return;
			}
		},
		async fetchUrl(){
			if (!this.user) return;
			if (this.isFetching) return;
			this.isFetching = true;
			try{
				let user = this.user;
				if (this.admin) {
					var res = await UserService.getLoginAsAdminUrl(user);
				}else{
					var res = await UserService.getLoginAsUserUrl(user);
				}
				this.url = res.url;
				this.expiryDate = res.expiryDate;
				this.expiryDate.setMinutes(this.expiryDate.getMinutes()-1);
				this.fetchedUserId = user.id;
			}catch(err) {
			}
			this.isFetching = false;
		}
	}
});
